import { render, staticRenderFns } from "./CambioEstatus.vue?vue&type=template&id=3a61ab44&"
import script from "./CambioEstatus.vue?vue&type=script&lang=js&"
export * from "./CambioEstatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports